import { useApiClient } from '@startupquickstart/frontend';
import { useQuery } from '@tanstack/react-query';

/** One readiness rule result from GET /events/:id/readiness. */
export interface ReadinessCheck {
  id: string;
  level: 'error' | 'warning';
  message: string;
  count: number;
  entityIds: string[];
}

export interface EventReadiness {
  ready: boolean;
  checks: ReadinessCheck[];
}

export const EVENT_READINESS_QUERY_KEY = 'EventReadiness';

/**
 * Fetches the pre-flight readiness report for an event: error-level checks
 * block publish/start; warnings are surfaced but don't block.
 */
export function useEventReadiness(eventId: string | undefined, enabled = true) {
  const apiClient = useApiClient();
  return useQuery<{ data: EventReadiness }>({
    queryKey: [EVENT_READINESS_QUERY_KEY, eventId],
    queryFn: () => apiClient.get(`/events/${eventId}/readiness`),
    enabled: Boolean(eventId) && enabled,
  });
}
